'use client';

import { useEffect } from 'react';
import { CustomQueryStringParameterItems } from 'libs/contentful/types';
import { extractAttributionFromItems, setAttributionCookie } from 'utils/attributionPersistence';

interface AttributionCookieSetterProps {
  customQueryStringParametersItems: CustomQueryStringParameterItems[];
}

export default function AttributionCookieSetter({ customQueryStringParametersItems }: AttributionCookieSetterProps) {
  useEffect(() => {
    const persistableParams = extractAttributionFromItems(customQueryStringParametersItems);
    if (Object.keys(persistableParams).length > 0) {
      setAttributionCookie(persistableParams);
    }
  }, [customQueryStringParametersItems]);

  return null;
}
